import { memo } from 'react';
import { GoMotoComponent } from '../../../API/GoMoto.types';

export const Footer: GoMotoComponent = memo(() => <footer />);
